import React from "react";

const emptycart = (data, category) => {
  return {
    type: "emptycart",
  };
};

export default emptycart;
